import { render, staticRenderFns } from "./adddocumenttemplate.vue?vue&type=template&id=af018ca6"
import script from "./adddocumenttemplate.vue?vue&type=script&lang=js"
export * from "./adddocumenttemplate.vue?vue&type=script&lang=js"
import style0 from "./adddocumenttemplate.vue?vue&type=style&index=0&id=af018ca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports